import {GameContextModel} from "../../../companies/game-context/game-context.model";

export enum GameStepsExecutionResultEnum {
    Continue,
    Cancel
}


export interface IGameRunStep {
    readonly isEnabled: boolean;
    disableGameStep(): this;
    enableGameStep(): this;
    executeStep(gameContext: GameContextModel): Promise<GameStepsExecutionResultEnum>;
    dispose(): void;
}